import { apiConstants, appConstants, sharedConstants } from './core/constants';

export const APP_CONSTANTS = {
  api: apiConstants,
  app: appConstants,
  shared: sharedConstants
};
